// 用户登录验证信息

export default {
    authenticated() {
        if (localStorage.getItem('token') && localStorage.getItem('token').length>0){
            return true
        }else{
            return false
        }
    },
    getToken() {
        return localStorage.getItem('token');
    },
    getLid() {
        return localStorage.getItem('lid');
    },
    logout() {
        localStorage.removeItem('token')
    }
}



// WEBPACK FOOTER //
// ./src/services/auth.js